module.exports = __webpack_public_path__ + "static/media/icon-piece6-3.963b42b3.png";